<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.5 27.5H6.25C4.86929 27.5 3.75 26.3807 3.75 25V5C3.75 3.61929 4.86929 2.5 6.25 2.5H12.5" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M21.25 20L26.25 15L21.25 10" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M26.25 15H11.25" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
